import { useState } from 'react';

import { useDebouncedValue } from '../../hooks/useDebouncedValue';

const DEBOUNCE_DELAY = 150;
const MIN_SEARCH_LENGTH = 3;

export const useArchitectSceneSearch = (initialSearchTerm = '') => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const debouncedSearchTerm = useDebouncedValue(searchTerm, DEBOUNCE_DELAY);
  const normalizedSearchTerm = debouncedSearchTerm.trim();

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm:
      normalizedSearchTerm.length >= MIN_SEARCH_LENGTH
        ? normalizedSearchTerm
        : '',
  };
};
